module.exports = __webpack_public_path__ + "img/disposed.154d9e0c.png";